const STAGES = new Set(['client_publication']);
const OUTCOMES = new Set([
    'succeeded',
    'terminal_failure',
    'abandoned',
]);
const FAILURE_CLASSES = new Set([
    'none',
    'contract',
    'http',
    'transport',
    'navigation_handoff',
]);
const INPUT_FIELDS = new Set([
    'stage',
    'outcome',
    'durationMs',
    'attemptCount',
    'failureClass',
]);

function nonnegativeInteger(name, value) {
    if (!Number.isSafeInteger(value) || value < 0) {
        throw new TypeError(`${name} must be a non-negative safe integer.`);
    }
    return value;
}

/**
 * Emit one fixed-schema browser metric with no user, revision, operation,
 * security, provider, auth, payload, or free-form error fields.
 */
export function emitWatchlistClientMetric(values) {
    try {
        if (!values || Object.keys(values).some((key) => !INPUT_FIELDS.has(key))) return false;
        const {
            stage,
            outcome,
            durationMs,
            attemptCount,
            failureClass = 'none',
        } = values;
        if (!STAGES.has(stage)) return false;
        if (!OUTCOMES.has(outcome)) return false;
        if (!FAILURE_CLASSES.has(failureClass)) return false;
        const metric = Object.freeze({
            event: 'watchlist_operation_metric',
            stage,
            outcome,
            failure_class: failureClass,
            duration_ms: nonnegativeInteger('durationMs', durationMs),
            attempt_count: nonnegativeInteger('attemptCount', attemptCount),
        });
        if (outcome === 'succeeded') {
            console.info('watchlist_operation_metric', metric);
        } else {
            console.warn('watchlist_operation_metric', metric);
        }
        return true;
    } catch (_error) {
        return false;
    }
}
